import React from "react";
import styled from "styled-components";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 10px;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  color: ${(props) => (props.valid ? "green" : "red")};
  margin-bottom: 5px;
  font-size: 14px;

  svg {
    margin-right: 8px;
  }
`;

const PasswordStrengthIndicator = ({ password }) => {
  const rules = [
    {
      label: "Pelo menos 6 caracteres",
      test: (pw) => String(pw).trim().length >= 6,
    },
    {
      label: "Letra maiúscula",
      test: (pw) => /[A-Z]/.test(pw),
    },
    {
      label: "Número",
      test: (pw) => /[0-9]/.test(pw),
    },
  ];

  return (
    <List>
      {rules.map((rule, index) => {
        const isValid = rule.test(password);
        return (
          <ListItem key={index} valid={isValid}>
            {isValid ? <FaCheckCircle /> : <FaTimesCircle />}
            {rule.label}
          </ListItem>
        );
      })}
    </List>
  );
};

export default PasswordStrengthIndicator;
